import React from 'react'
import { Col } from 'react-bootstrap'
import { Filter } from 'components/Filter'
import * as S from './styles'

// Props for the SearchBar component
interface SearchBarProps {
  searchTerm: string
  onChange: (value: string) => void
}

export const SearchBar = ({ searchTerm, onChange }: SearchBarProps): JSX.Element => {
  return (
    <S.SearchRow>
      <Col md={6}>
        <S.FilterWrapper>
          <Filter
            currentSearchTerm={searchTerm}
            btnClick={(term: string) => onChange(term)}
            onFilterChange={(term: string) => onChange(term)}
          />
        </S.FilterWrapper>
      </Col>
    </S.SearchRow>
  )
}